import { render, staticRenderFns } from "./consentStatus.vue?vue&type=template&id=76d33cf5&scoped=true"
import script from "./consentStatus.vue?vue&type=script&lang=js"
export * from "./consentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d33cf5",
  null
  
)

export default component.exports